import Vue from 'vue'
import Router from 'vue-router'
import  Customer  from "@/view/yhBind/Customer"
import SearchUser from '@/view/yhBind/searchUser'
import Payment from '@/view/jryw/jf/Payment'
import UserList from '@/view/yhBind/UserList'
import bindComponey from '@/view/yhBind/bindComponey'
import baoxiu from '@/view/ywbl/bx/baoxiu'
import baoxiuList from '@/view/ywbl/bx/baoxiuList'
import menuList from '@/view/menuList/index'
import qRcode from '@/view/fzxx/qRcode'
import pj from '@/view/ywbl/bx/pingjia'
import payList from '@/view/jryw/jf/payList'
import userNameList from '@/view/yhBind/userNameList'
import getSeverMsg from '@/view/xxcx/getSeverMsg'
import scanCode from '@/view/yhBind/scanCode'
import changeInfo from '@/view/ywbl/gm/changeInfo'
import changeStatus from '@/view/ywbl/tg/changeStatus'
import zhengcefagui from "@/view/xxcx/zhengcefagui";
import zcfgneirong from "@/view/xxcx/zcfgneirog";
import changjianwenti from "@/view/xxcx/changjianwenti";
import jiaofeizhinan from "@/view/xxcx/jiaofeizhinan";
import feiyongbiaozhun from "@/view/xxcx/feiyongbiaozhun";
import banshizhinan from "@/view/xxcx/banshizhinan";
import yuyuefuwu from "@/view/ywbl/yuyue/yuyuefuwu";
import tousujianyi from "@/view/ywbl/tousu/tousujianyi";
import cewenshenqing from "@/view/ywbl/cw/cewenshenqing";
import fuwuwangdian from "@/view/xxcx/fuwuwangdian";
import tgList from "@/view/ywbl/tg/tgList";
import gmList from "@/view/ywbl/gm/gmList";
import jjyy from '@/view/ywbl/jjyy';
import moreBind from "@/view/yhBind/moreBind";
import bindList from "@/view/yhBind/bindList";
import setPassword from "@/view/fzxx/setPassword/setPassword";
import checkPassword from "@/view/fzxx/setPassword/checkPassword";
import fgList from "@/view/ywbl/fg/fgList";
import fgChange from '@/view/ywbl/fg/changeStatus'
import detailPage from '@/view/xxcx/detailPage'
import typePage from '@/view/xxcx/typePage'
import hzyh from "@/view/xxcx/hzyh";
import mjbg from '@/view/ywbl/mjbg';
import dzfp from '@/view/ywbl/dzfp/dkpList';
import SubmitKp from '@/view/ywbl/dzfp/SubmitKp'
import mjbgList from "@/view/ywbl/mjbg/mjbgList";
import hezuoyinhang from "@/view/xxcx/hezuoyinhang";
import bindUserTj from "@/view/yhBind/bindUserTj";
import yhcw from '@/view/ywbl/yhcw/index';
import wsfz from '@/view/ywbl/wsfz';
import yhxxxg from '@/view/ywbl/wsfz/yhxxxg'
import jymm from '@/view/ywbl/wsfz/jymm'
import rwsh from '@/view/ywbl/rwsq/index'
import rwList from '@/view/ywbl/rwsq/rwList'
Vue.use(Router)

const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'UserList',
      component: UserList,
      meta: {
        title: '用户列表'
      }
    },
    {
      path: '/userPayList',
      name: 'UserList',
      component: UserList,
      meta: {
        title: '用户列表'
      }
    },
    {
      path: '/userBaoxiuList',
      name: 'UserList',
      component: UserList,
      meta: {
        title: '用户列表'
      }
    },
    {
      path: '/customer',
      name: '用户绑定',
      component: Customer,
      meta: {
        title: '绑定用户'
      }
    },
    {
      path: '/payment',
      name: '缴费',
      component: Payment,
      meta: {
        title: '供热缴费'
      }
    },
    {
      path: '/searchUser',
      name: 'searchUser',
      component: SearchUser,
      meta: {
        title: '搜索用户'
      }
    },
    {
      path: '/userList/:path',
      name: 'userList',
      component: UserList,
      meta: {
        title: '用户列表'
      }
    },
    {
      path: '/bindComponey',
      name: 'bindComponey',
      component: bindComponey,
      meta: {
        title: '绑定公司'
      }
    },
    {
      path: '/baoxiu',
      name: 'baoxiu',
      component: baoxiu,
      meta: {
        title: '故障报修'
      }
    },
    {
      path: '/baoxiuList',
      name: 'baoxiuList',
      component: baoxiuList,
      meta: {
        title: '故障报修'
      }
    },
    {
      path: '/menuList',
      name: 'menuList',
      component: menuList,
      meta: {
        title: '客户服务大厅'
      }
    },
    {
      path: '/qRcode',
      name: 'qRcode',
      component: qRcode,
      meta: {
        title: '我的二维码'
      }
    },
    {
      path: '/pj/:taskId',
      name: 'pj',
      component: pj,
      meta: {
        title: '用户评价'
      }
    },
    {
      path: '/payList',
      name: 'payList',
      component: payList,
      meta: {
        title: '缴费记录'
      }
    },
    {
      path: '/userNameList',
      name: 'userNameList',
      component: userNameList,
      meta: {
        title: '用户列表'
      }
    },
    {
      path: '/getSeverMsg',
      name: 'getSeverMsg',
      component: getSeverMsg,
      meta: {
        title: '获取'
      }
    },
    {
      path: '/scanCode',
      name: 'scanCode',
      component: scanCode,
      meta: {
        title: '扫码'
      }
    },
    {
      path: '/changeInfo',
      name: 'changeInfo',
      component: changeInfo,
      meta: {
        title: '更名过户'
      }
    },
    {
      path: '/changeStatus',
      name: 'changeStatus',
      component: changeStatus,
      meta: {
        title: '申请停热'
      }
    },
    {
      path: '/zhengcefagui',
      name: 'zhengcefagui',
      component: zhengcefagui,
      meta: {
        title: '政策法规'
      }
    },
    {
      path: '/zcfgneirong',
      name: 'zcfgneirong',
      component: zcfgneirong,
      meta: {
        title: '客户服务大厅'
      }
    },
    {
      path: '/changjianwenti',
      name: 'changjianwenti',
      component: changjianwenti,
      meta: {
        title: '热点问题'
      }
    },
    {
      path: '/jiaofeizhinan',
      name: 'jiaofeizhinan',
      component: jiaofeizhinan,
      meta: {
        title: '用热常识'
      }
    },
    {
      path: '/feiyongbiaozhun',
      name: 'feiyongbiaozhun',
      component: feiyongbiaozhun,
      meta: {
        title: '费用标准'
      }
    },
    {
      path: '/banshizhinan',
      name: 'banshizhinan',
      component: banshizhinan,
      meta: {
        title: '业务指南'
      }
    },
    {
      path: '/yuyuefuwu',
      name: 'yuyuefuwu',
      component: yuyuefuwu,
      meta: {
        title: '预约服务'
      }
    },
    {
      path: '/tousujianyi',
      name: 'tousujianyi',
      component: tousujianyi,
      meta: {
        title: '投诉建议'
      }
    },
    {
      path: '/cewenshenqing',
      name: 'cewenshenqing',
      component: cewenshenqing,
      meta: {
        title: '测温申请'
      }
    },
    {
      path: '/fuwuwangdian',
      name: 'fuwuwangdian',
      component: fuwuwangdian,
      meta: {
        title: '服务网点'
      }
    },
    {
      path: '/hezuoyinhang',
      name: 'hezuoyinhang',
      component: hezuoyinhang,
      meta: {
        title: '合作银行'
      }
    },
    {
      path: '/tgList',
      name: 'tgList',
      component: tgList,
      meta: {
        title: '申请停热'
      }
    },
    {
      path: '/gmList',
      name: 'gmList',
      component: gmList,
      meta: {
        title: '更名过户'
      }
    },
    {
      path: '/jjyy',
      name: 'jjyy',
      component: jjyy,
      meta: {
        title: '拒绝原因'
      }
    },
    {
      path: '/moreBind',
      name: 'moreBind',
      component: moreBind,
      meta: {
        title: '用户绑定'
      }
    },
    {
      path: '/bindList',
      name: 'bindList',
      component: bindList,
      meta: {
        title: '查询列表'
      }
    },
    {
      path: '/setPassword',
      name: 'setPassword',
      component: setPassword,
      meta: {
        title: '设置密码'
      }
    },
    {
      path: '/fgChange',
      name: 'fgChange',
      component: fgChange,
      meta: {
        title: '申请复供'
      }
    },
    {
      path: '/fgList',
      name: 'fgList',
      component: fgList,
      meta: {
        title: '申请复供'
      }
    },
    {
      path: `/detailPage/:ywmc`,
      name: 'detailPage',
      component: detailPage,
      meta: {
        title: '客户服务大厅'
      }
    },
    {
      path: `/typePage/:type`,
      name: 'typePage',
      component: typePage,
      meta: {
        title: '客户服务大厅'
      }
    },
    {
      path: `/hzyh`,
      name: 'hzyh',
      component: hzyh,
      meta: {
        title: '合作银行'
      }
    },
    {
      path: '/mjbg',
      name: 'mjbg',
      component: mjbg,
      meta: {
        title: '面积变更'
      }
    },
    {
      path: '/mjbgList',
      name: 'mjbgList',
      component: mjbgList,
      meta: {
        title: '面积变更'
      }
    },
    {
      path: '/dzfp',
      name: 'dzfp',
      component: dzfp,
      meta: {
        title: '电子发票'
      }
    },
    {
      path: '/kjfp',
      name: 'kjfp',
      component: SubmitKp,
      meta: {
        title: '电子发票'
      }
    },
    {
      path: '/bindUserTj',
      name: 'bindUserTj',
      component: bindUserTj,
      meta: {
        title: '用户绑定'
      }
    },
    {
      path: '/yhcw',
      name: 'yhcw',
      component: yhcw,
      meta: {
        title: '用户测温'
      }
    },
    {
      path: '/wsfz',
      name: 'wsfz',
      component: wsfz,
      meta: {
        title: '我是房主'
      }
    },
    {
      path: '/yhxxxg',
      name: 'yhxxxg',
      component: yhxxxg,
      meta: {
        title: '用户信息修改'
      }
    },
    {
      path: '/jymm',
      name: 'jymm',
      component: jymm,
      meta: {
        title: '确认密码'
      }
    },
    {
      path: '/rwsh',
      name: 'rwsh',
      component: rwsh,
      meta: {
        title: '入网申请'
      }
    },
    {
      path: '/rwList',
      name: 'rwList',
      component: rwList,
      meta: {
        title: '入网申请查询'
      }
    }

  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js